module.exports = __webpack_public_path__ + "img/icon_benefit_05_02.b15a3056.svg";